import { IconContent } from '@icons';

export const calendar: IconContent = {
    md: '<path fill-rule="evenodd" d="M7.5 6H4v3.5h16V6h-3.5v2h-1V6h-7v2h-1V6Zm1-1h7V3h1v2H20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.5V3h1v2ZM4 19v-8.5h16V20H4v-1Z" />',
};
